"use strict";

const _ = require('underscore');

class DebugContextOption {
    constructor(options) {
        this._options = _.extend(_.clone(DebugContextOption.OPTIONS_DEFAULT), options);
    }

    _get(key) {
        return _.result(this._options, key, true);
    }

    isEnabled(key) {
        return this._get(key);
    }

    isDisabled(key) {
        return ! this._get(key);
    }

    setMode(key, mode) {
        if (!DebugContextOption.OPTIONS_INVERT[key]) {
            return;
        }

        switch(mode && mode.toLowerCase()) {
            case 'enabled':
                this._options[key] = true;
                break;
            case 'disabled':
                this._options[key] = false;
                break;
        }
    }

    toJSON() {
        return this._options;
    }

    toTemplateContext() {
        const j = [];
        _.each(this._options, (value, key) => {
            j.push({
                urlKey: DebugContextOption.OPTIONS_INVERT[key],
                feature: key, // 機能名
                value: value, // 現在の設定値 (true or false)
                state: value ? 'enabled' : 'disabled', // 現在の設定値
                change_to: value ? 'disabled' : 'enabled', // 変更後の設定値
            });
        });

        return j;
    }

    trackJSIsEnabled() {
        return this.isEnabled('TrackJS');
    }

    firebaseIsEnabled() {
        return this.isEnabled('firebase');
    }

    reverseProxyIsDisabled() {
        return this.isDisabled('ReverseProxy');
    }
}

DebugContextOption.OPTIONS = {
    debugReverseProxy: 'ReverseProxy',
    debugTrackJS: 'TrackJS',
    debugFirebase: 'firebase'
};

DebugContextOption.OPTIONS_INVERT = _.invert(DebugContextOption.OPTIONS);

DebugContextOption.OPTIONS_DEFAULT = {};
_.each(_.keys(DebugContextOption.OPTIONS_INVERT), (key) => {
    DebugContextOption.OPTIONS_DEFAULT[key] = true;
});


class DebugContext {
    constructor(token, enabled=false, tngVersion=null, options={}) {
        this._token = token;
        this._enabled = !!enabled;
        this._tngVersion = tngVersion;
        this._options = new DebugContextOption(_.extend({}, options));

        this._empty_options = new DebugContextOption({});
    }

    getToken() {
        return this._token;
    }

    isEnabled() {
        return this._enabled;
    }

    isDisabled() {
        return ! this.isEnabled();
    }

    setMode(mode) {
        switch(mode.toLowerCase()) {
            case 'enabled':
                this._enabled = true;
                break;
            case 'disabled':
                this._enabled = false;
                break;
        }
    }

    setTNGVersion(tngVersion) {
        if (tngVersion === "") {
            this._tngVersion = null;
        } else {
            this._tngVersion = tngVersion;
        }
    }

    getTNGVersion() {
        return this._tngVersion;
    }

    getOptions() {
        if (this.isEnabled()) {
            return this._options;
        } else {
            return this._empty_options;
        }
    }

    setOptionMode(optionKey, mode) {
        this._options.setMode(optionKey, mode);
    }

    toJSON() {
        return {
            token: this._token,
            enabled: this._enabled,
            tngVersion: this._tngVersion,
            options: this._options.toJSON(),
        }
    }

    static loadJSON(json) {
        const token = json.token;
        const enabled = json.enabled;
        const tngVersion = json.tngVersion;
        const options = json.options;

        return new this(token, enabled, tngVersion, options)
    }

    toTemplateContext() {
        const json = {
            token: this._token,
            enabled: this._enabled,
            tngVersion: this._tngVersion,
            options: this._options.toTemplateContext(),
        };
        return json;
    }
}

DebugContext.OPTIONS = DebugContextOption.OPTIONS;
DebugContext.DebugContextOption = DebugContextOption;

module.exports = DebugContext;



// WEBPACK FOOTER //
// ./common/util/debug-context/debug-context.js